export { isNonEmptyString } from './isNonEmptyString';
export { isIosApp } from './stitchfixApp';
export { isLocal } from './isLocal';
export { getParams } from './getParams';
export { themeMapping } from './themeMapping';
export const REMEMBER_USER_COOKIE_NAME = 'remember_user_token' as const;
export const ACCEPT_INVITE_COOKIE_NAME = 'referral_redesign_title' as const;
export const DYNAMIC_ADS_COOKIE_NAME = 'dpa_grouping' as const;
export const IOS_APP_AUTH_COOKIE_OVERRIDE_FEATURE_FLAG_NAME =
  'client.web.auth_cookie_override_ios_app' as const;
export const HOUSEHOLD_PROFILES_CONFIG_PARAM_NAME =
  'eng.omniclient.household_profiles_buying_for_others' as const;
export const CONTEXTUAL_ONBOARDING_CONFIG_PARAM_NAME =
  'onb.contextualized_onboarding_redux' as const;
export const STYLEFILE_REFRESH_CONFIG_PARAM_NAME =
  'eng.kufak.stylefile_seasonal_refresh' as const;
